<template>
	<div
		class="app-preloader d-flex fill-height overflow-hidden"
		:style="paddingY ? `padding-top: ${paddingY}px; padding-bottom: ${paddingY}px;` : ''"
	>
		<div class="ma-auto">
			<v-progress-circular
				v-if="variant === 'circular'"
				indeterminate
				:size="size"
				:width="width"
				color="primary"
			/>
			<v-progress-linear
				v-else-if="variant === 'linear'"
				indeterminate
				color="primary"
				height="2"
				:style="[`width: ${size}px`]"
			/>
		</div>
	</div>
</template>

<script setup>
defineProps({
	size: {
		type: Number,
		default: 64,
	},
	width: {
		type: Number,
		default: 4,
	},
	paddingY: {
		type: Number,
		default: 0,
	},
	variant: {
		type: String,
		default: 'circular',
	},
})
</script>
